import { Box, Typography } from '@mui/material'
import React from 'react'

export default function reportNameColumn() {

	return [ {
		name: 'reportName',
		label: 'Report Name',
		options: {
			display: 'excluded',
			filterType: 'textField',
			customBodyRowRenderLite: value => value,
		},
	}, {
		name: 'reportName',
		label: 'Report Name',
		options: {
			filter: false,
			headerAlign: 'left',
			customBodyRowRenderLite: value => (
				<Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'start' }}>
					<Typography sx={{ fontWeight: 'bold' }}>{value}</Typography>
				</Box>
			),
		},
	} ]
}
